<template>
  <div class="container">
    <div class="index-head">
      <component :is="isComponent" :isNav="isNav" :isHome="isHome"></component>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <div class="index-foot"><foot></foot></div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {};
  },
  watch: {},
  computed: {
    isComponent() {
      return [
        `Home`,
        `ShowNews`,
        `ShowNewsDetail`,
        `ShowPrivacyPolicy`,
        `ShowHelp`,
        "ShowMessage",
        "showAcrobatics",
        "showStory",
        "CompanyGrow",
        "CompanyHonor",
        "PrivacyRules",
        "RecruitmentSkills",
        "JobHuntingSkills",
        "DSDownload",
        "PADownload",
        "VIPDownload",
        "YCDownload",
        "JobEmployment",
        "bpAiGlass",
        "EnterpriseUserDesktop",
        "CompanyRelation",
        "bpInvest",
        "CompanyFinancing",
        "CompanyMiddleAndSmall",

        "EnterpriseHome",
        "EnterpriseServer",
        "EnterpriseCase",
      ].indexOf(this.$route.name) !== -1
        ? `navbar`
        : `heads`;
    },
    isNav() {
      return (
        [
          `CompanyIntr`,
          `CompanyIssue`,
          `CompanyRelation`,
          `CompanyCourse`,
        ].indexOf(this.$route.name) === -1
      );
    },
    isHome() {
      const showHeader = [
        "Home",
        "DSDownload",
        "VIPDownload",
        "YCDownload",
        "JobEmployment",
        "EnterpriseUserDesktop",
      ];
      return showHeader.includes(this.$route.name);
    },
  },
};
</script>

<style scoped="scoped">
@import url("./index.css");
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue